/**
 * Tint steps every COLOR_STYLES value supports, as a percentage of the style's color.
 * Keep in sync with $color-style-tint-steps in sass/_color_styles.scss
 */
export const COLOR_TINT_STEPS = [10, 20, 30, 40, 50, 60, 70, 80, 90];
const TINT_SUFFIX = new RegExp(`-(${COLOR_TINT_STEPS.join('|')})$`);
/**
 * Builds the name for a tint of a color style, e.g. colorTint(BUTTON_COLOR_STYLES.PRIMARY, 20)
 * returns 'primary-20'
 */
export function colorTint(style, step) {
    return `${style}-${step}`;
}
/**
 * Returns the style a tint is based on, e.g. 'primary-20' returns 'primary'. Names without a tint
 * step are returned unchanged
 */
export function colorTintBase(style) {
    return style.replace(TINT_SUFFIX, '');
}
//# sourceMappingURL=ColorTint.js.map